import React from 'react';
import styled from 'styled-components';
import { BodyText, FlexColumn } from '@make-software/cspr-design';
import { InfoSection } from 'app/components/management/common/info-section/info-section';
import { AppEnvs } from 'config/env';

export interface RawDetailsProps {
  withPageTile?: boolean;
  marginTop?: string;
}

const StyledWrapper = styled.div`
  font-family: Arial, sans-serif;
`;

const SupportInfo = styled.div<{ marginTop?: string }>(({ theme, marginTop }) =>
  theme.withMedia({
    width: ['50%', '65%', '100%'],
    marginTop: marginTop ? marginTop : '20px',
    fontSize: '0.9em'
  })
);

const ApiSnippet = styled.pre`
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-word; // break long words if needed
  overflow-wrap: anywhere; // modern way to ensure wrapping
`;

export const IntegrationInstructions = ({ marginTop }: RawDetailsProps) => {
  const urlCode = `POST ${AppEnvs.integrationAPIURL}/plugins/action-based/track`;

  const bodyFormatCode = `{
  "action": "<Name of action from the task>",
  "userID": "<TG User ID>",
  "timestamp": <int64 UTC time generated by server>
}`;

  const rawDetailsComponent = (
    <StyledWrapper>
      <SupportInfo marginTop={marginTop}>
        <InfoSection
          title={'Backend API integration'}
          content={
            <>
              <FlexColumn>
                <BodyText size={1}>API endpoint:</BodyText>
                <ApiSnippet>{urlCode}</ApiSnippet>
              </FlexColumn>
              <FlexColumn>
                <BodyText size={1}>Request body format:</BodyText>
                <ApiSnippet>{bodyFormatCode}</ApiSnippet>
              </FlexColumn>
            </>
          }
        />
      </SupportInfo>
    </StyledWrapper>
  );

  return rawDetailsComponent;
};
